import { Form, Link, useActionData } from "@remix-run/react";
import Input from "~/components/Input";
import Button from "~/components/Button";
import type { ActionFunctionArgs, MetaFunction } from "@remix-run/node";
import { redirect, json } from "@remix-run/node";
import { defaultMetaTagsBuilder } from "~/utils/meta";
import { forgotPassword } from "~/services/forgotPassword.server";

export const meta: MetaFunction = ({ location }) => {
  const url = new URL(location.pathname, "https://app.7qz.io");
  return defaultMetaTagsBuilder({
    title: "Forgot Password",
    description: "Reset your account password",
    url: url,
  });
};

export default function ForgotPasswordEmail() {
  const actionData = useActionData<typeof action>();

  return (
    <>
      <div className={"mt-4 text-white"}>
        Enter your email and we'll send you a confirmation code to get you back
        into your account
      </div>
      <Form method="post" reloadDocument={true}>
        <div>
          <Input
            name={"email"}
            label={"Email"}
            required={true}
            defaultValue={actionData?.values?.email}
            error={!!actionData?.errorMessage}
          />
          {actionData?.errorCode === "USER_NOT_FOUND" && (
            <div className={"mb-8 text-red-500"}>
              Account doesn't exist. Try again or &nbsp;
              <Link className={"cursor-pointer underline"} to={"/signup"}>
                create an account
              </Link>
              .
            </div>
          )}
        </div>
        <Button label={"Submit"} type={"submit"} styleType={"primary"} />
      </Form>
    </>
  );
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const email = formData.get("email") as string;

  if (!email) {
    return json({
      success: false,
      errorMessage: "Email is required",
      errorCode: "EMAIL_REQUIRED",
      values: {
        email,
      },
    });
  }

  const forgotPasswordResult = await forgotPassword(email);

  if (!forgotPasswordResult.success) {
    return json({
      success: false,
      errorMessage:
        forgotPasswordResult?.error?.message ?? "An error has occurred",
      errorCode: forgotPasswordResult?.error?.code ?? "UNKNOWN_ERROR",
      values: {
        email,
      },
    });
  }

  return redirect("/forgot-password/email-sent");
}
